import React from "react";
import { ToastContainer } from "react-toastify";

const ToastProvider = ({ children }) => {
  return (
    <>
      {children}
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default ToastProvider;
